import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter, Route, Switch, Redirect } from "react-router-dom";

import './i18n';
import AdminLayout from "layouts/Admin.js";
import ScrollToTop from "./components/ScrollToTop/ScrollToTop";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <ScrollToTop />
      <Switch>
        <Route path={`/`} component={AdminLayout} />
        <Redirect from={`/`} to="/home" />
      </Switch>
    </BrowserRouter>
  </React.StrictMode>
);
